import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AppState } from 'app/store'
import ClassRooms, {ClassRoom} from 'services/modals/ClassRooms'
import { studentApi } from 'services/studentApi'

interface StudentState {
  classrooms: ClassRooms
  currentClassroom: ClassRoom | null
}

const initialState: StudentState = {
  classrooms: [],
  currentClassroom: null
}

export const studentSlice = createSlice({
  name: 'studentReducer',
  initialState,
  reducers: {
    setClassrooms: (state, action: PayloadAction<ClassRooms>) => {
      state.classrooms = action.payload
    },
    setCurrentClassroom: (state, action: PayloadAction<ClassRoom | null>) => {
      state.currentClassroom = action.payload
    },
    resetStudentReducer: () => initialState
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      studentApi.endpoints.getStudentClassrooms.matchFulfilled,
      (state, action) => {
        state.classrooms = action.payload.classrooms
      }
    )
  }
})

export default studentSlice.reducer

export const { setClassrooms, resetStudentReducer, setCurrentClassroom } = studentSlice.actions

export const selectClassrooms = (state: AppState) =>
  state.studentReducer.classrooms

export const selectCurrentClassroom = (state: AppState) =>
  state.studentReducer.currentClassroom
